<header
  [ngClass]="topPosition ? 'big' : 'small'"
  *transloco="let t; read: 'header'"
>
  <div class="header">
    <a class="home-link" [routerLink]="['/home']"></a>
    <input type="checkbox" id="menu-toggle-checkbox" />
    <label for="menu-toggle-checkbox"
      ><i class="menu">menu</i><i class="close">close</i></label
    >
    <ul class="menu">
      <li>
        <a [routerLink]="['/home']" [routerLinkActive]="['active']">{{
          t("home")
        }}</a>
      </li>
      <li>
        <a [routerLink]="['/benefit']" [routerLinkActive]="['active']">{{
          t("benefit")
        }}</a>
      </li>
      <li>
        <a [routerLink]="['/functions']" [routerLinkActive]="['active']">{{
          t("functions")
        }}</a>
      </li>
      <li>
        <a [routerLink]="['/faq']" [routerLinkActive]="['active']">FAQ</a>
      </li>
      <li>
        <a [routerLink]="['/blog']" [routerLinkActive]="['active']">Blog</a>
      </li>
      <li>
        <a [routerLink]="['/contact']" [routerLinkActive]="['active']">{{
          t("contact")
        }}</a>
      </li>
      <!-- <li>
        <a [routerLink]="['/webinar']" [routerLinkActive]="['active']">{{
          t("webinar")
        }}</a>
      </li> -->
      <li>
        <a [routerLink]="['/appointment']" [routerLinkActive]="['active']">{{
          t("appointment")
        }}</a>
      </li>
      <li class="videolink">
        <a [routerLink]="['/video']" [routerLinkActive]="['invisible']">{{
          t("show-video")
        }}</a>
      </li>
    </ul>
    <ul class="language-selector" *ngIf="topPosition">
      <li class="language-link">
        <button class="lang-selector" (click)="switchToGerman()">
          Deutsch
        </button>
      </li>
      <li class="language-link">
        <button class="lang-selector" (click)="switchToEnglish()">
          English
        </button>
      </li>
    </ul>
    <a
      id="video"
      [routerLink]="['/video']"
      [routerLinkActive]="['invisible']"
      >{{ t("open-video") }}</a
    >
    <a
      id="direct-start"
      class="call small"
      [routerLink]="['/download']"
      [routerLinkActive]="['invisible']"
      >{{ t("direct-start") }}</a
    >
  </div>
</header>

<main>
  <router-outlet></router-outlet>
</main>

<footer *transloco="let t; read: 'footer'">
  <div class="footer">
    <div>
      <h3>{{ t("about") }}</h3>
      <ul>
        <li>
          <a [routerLink]="['/download']">{{ t("software-test") }}</a>
        </li>
        <li>
          <a [routerLink]="['/faq']">{{ t("faq") }}</a>
        </li>
        <li>
          <a [routerLink]="['/functions']">{{ t("functions") }}</a>
        </li>
        <li>
          <a [routerLink]="['/training']">{{ t("training") }}</a>
        </li>
        <li>
          <a [routerLink]="['/contact']">{{ t("contact") }}</a>
        </li>
      </ul>
    </div>
    <div>
      <h3>{{ t("legal-notes") }}</h3>
      <ul>
        <li>
          <a [routerLink]="['/imprint']">{{ t("imprint") }}</a>
        </li>
        <li>
          <a [routerLink]="['/privacy']">{{ t("privacy") }}</a>
        </li>
      </ul>
    </div>
    <div class="copyright">
      <div>
        {{ t("provider-note") }}
        <a href="https://www.isb-ik.de" target="blank"
          ><img src="assets/isb_logo_weiss.png"
        /></a>
      </div>
    </div>
  </div>
</footer>
<div class="copyright-note" *transloco="let t; read: 'footer'">
  &copy; 2025 video2manual. {{ t("copyright-note") }}
</div>
<!-- <cookie-law
  >Diese Website verwendet Cookies. Nähere Informationen dazu finden Sie in
  unserer <a [routerLink]="['/privacy']">Datenschutzerklärung</a>.<br />Durch
  die Nutzung der Website akzeptieren Sie die Verwendung von
  Cookies.</cookie-law
> -->
